import Axios from "axios";

import { $authUrl } from "..";

const authBaseUrl = `${$authUrl}auth`;
const config = {
  headers: { "Content-Type": "application/json-patch+json" }
};

export const passwordApi = {
  passwordResetRequest: userNameOrEmail => {
    return Axios.post(
      `${authBaseUrl}/resetPasswordRequest`,
      JSON.stringify({userNameOrEmail}),
      config
    );
  },
  resetPasswordOrig: (userNameOrEmail) => {
    return Axios.post(
      `${authBaseUrl}/resetPasswordOrig`,
      JSON.stringify({ userNameOrEmail}),
      config
    );
  },
  resetPassword: (userOrEmail, password, token) => {
    return Axios.post(
      `${authBaseUrl}/resetPassword`,
      JSON.stringify({ userOrEmail, password, token }),
      config
    );
  },
  resetUserPassword: (currentPassword, password) => {
    return Axios.post(
      `${authBaseUrl}/resetUserPassword`,
      JSON.stringify({currentPassword, password }),
      config
    );
  },
  requiredPasswordChange: (currentPassword: string, password: string) => {
    return Axios.post(
      `${authBaseUrl}/required-password-change`,
      JSON.stringify({ currentPassword, password }),
      config
    );
  }
};
